import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Col, Row, Button } from 'reactstrap';
import { Dialog } from 'primereact/dialog';

export const ModalPreViewMedicalOrder = (props) => {

    const {
        modal, closeDialog, workMedicalOrderPDF, workMedicalOrderPDFDownload, typeModal, workMedicalOrderPDFLoading = "view",loadingPdf,
    } = props;

    return (
       

        <Dialog
                className='custom-dialog-preview-invoice'
                header="Previsualización de Resultados"
                visible={modal}
                // style={{ width: '60vw', maxWidth: '700px' }}
                modal
                closable={true}
                dismissableMask
                onHide={closeDialog}
                headerStyle={{
                    backgroundColor: '#0d3b59',
                    color: 'white',
                    fontWeight: 'bold',
                }}
                footer={
                    <div className={!workMedicalOrderPDFLoading ? "" : "d-none"} >
                       
                        <Button size="lg" block outline color="success" href={workMedicalOrderPDFDownload} target="_blank" rel="noopener noreferrer">
                            <i className="icofont icofont-file-excel" /> Descargar Documento
                        </Button>
                    </div>
                }

            >
            {
                typeModal === "view" ?
                    <ModalBody>
                        {
                            workMedicalOrderPDFLoading == true ?
                                <div className="text-center">
                                    Cargando...
                                </div>
                                :
                             
                                <Col sm="12">
                                    <embed src={workMedicalOrderPDF} title="Previsualizador" type="application/pdf" width="100%" height="600px" />
                                </Col>
                              
                        }
                    </ModalBody>
                    : ""
            }
    

        </Dialog>
    )
}